import React from 'react'
import { observer } from "mobx-react-lite"
import Button from '@mui/material/Button';
import { GoogleLogin } from 'react-google-login';
import {ReactComponent as GoogleIcon} from '../../images/google.svg';
import userStore from '../common/userStore';


// login signup
const GoogleButton = observer(({className}) => {

  const responseGoogle = async(response) => {
    console.log(response);
    if (response.error) {
      return;
    }
    console.log(response.tokenId)
    const rs = await userStore.loginByGoogle(response)
    // if (rs) {
    //   console.log('google redirect to home')
    //   window.location.replace('/')
    // }
  }

  return  <GoogleLogin 
      clientId="192719829403-t98fvedua7tob65h2qqi6i6p6ngl62db.apps.googleusercontent.com" 
      onSuccess={responseGoogle} 
      onFailure={responseGoogle} 
      isSignedIn={false}
      render={(renderProps) => {
      return <Button startIcon={<GoogleIcon width="24px" />} 
          className={className} 
          onClick={renderProps.onClick} 
          disabled={renderProps.disabled}>Google</Button>
    }} />
})

export default GoogleButton